export enum SIGNERS {
    WALLET = 'wallet',
    ALGO_SIGNER = 'algo_signer',
    LOGIC_SIG = 'logic_sig',
    MY_ALGO_WALLET = 'my_algo_wallet',
    PERA_WALLET = 'pera_wallet',
    DEV_WALLET = 'DEV_WALLET'
}

export enum ALGO_SIGNER_NET {
    BETANET = "BetaNet",
    TESTNET = 'TestNet',
    MAINNET = 'MainNet',
    SANDBOX = 'sandnet-v1'
}
